import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { fetch_payout_deleted_teacher } from '../../teacher_payments/api';
import {
  DELETED_ACCOUNTS_LINK,
  can_see_deleted_accounts,
  deleted_teacher_banner,
  deleted_teacher_failed_text
} from '../../teacher_payments/payouts/deleted_alert';

// a deleted account with money due, on the teacher profile. Read only for the payouts roles (anyone
// else would get a 403); a 5xx or no answer shows a "could not check" warning instead of nothing.
const STYLE = {
  background: 'var(--state-error-bg)',
  border: '1px solid var(--state-error)',
  color: 'var(--state-error-text)',
  borderRadius: 7,
  padding: '9px 13px',
  fontSize: 13,
  margin: '12px 0'
};

const UNKNOWN_STYLE = {
  ...STYLE,
  background: 'var(--state-warning-bg)',
  border: '1px solid var(--state-warning)',
  color: 'var(--state-warning-text)'
};

const DeletedMoneyDueBanner = ({ teacher_uuid, access_type }) => {
  const [text, setText] = useState(null);
  const [unknown, setUnknown] = useState(null);
  const allowed = can_see_deleted_accounts(access_type);
  useEffect(() => {
    setText(null);
    setUnknown(null);
    if (!teacher_uuid || !allowed) return undefined;
    let cancelled = false;
    fetch_payout_deleted_teacher(teacher_uuid)
      .then((data) => {
        if (!cancelled) setText(deleted_teacher_banner(data));
      })
      .catch((e) => {
        if (cancelled) return;
        const failed = deleted_teacher_failed_text(e);
        if (failed)
          console.error('deleted-account money-due read failed', e?.response?.status || e?.message);
        setUnknown(failed);
      });
    return () => {
      cancelled = true;
    };
  }, [teacher_uuid, allowed]);

  if (unknown) {
    return (
      <div style={UNKNOWN_STYLE} role="status">
        {unknown}
      </div>
    );
  }
  if (!text) return null;
  return (
    <div style={STYLE} role="alert">
      {text} – <Link to={DELETED_ACCOUNTS_LINK}>Review in Bank payouts</Link>
    </div>
  );
};

export default DeletedMoneyDueBanner;
